/**
 * Usage: see MeetingArtifacts in EdgeworthItemControl
 * @param parentElement Container element that contains the array of child elements that have overflowing behavior
 * @param childClassName String that contains the className shared by child elements (must not be reused by the overflow menu)
 * @param elementsMargin Margin between child elements (excluding last element)
 * @returns an array with the sum of widths (in pixels) at that index
 */
export function getWidthArray(parentElement, childClassName, elementsMargin) {
    if (!parentElement || parentElement.children.length === 0) {
        return null;
    }
    var firstElementMargin = parentElement.children.length === 1 || !elementsMargin
        ? 0
        : elementsMargin;
    var widthArray = [
        parentElement.children[0].offsetWidth +
            firstElementMargin,
    ];
    for (var i = 1; i < parentElement.children.length; i++) {
        var containerItem = parentElement.children[i];
        if (!childClassName ||
            containerItem.className.includes(childClassName)) {
            var margin = i === parentElement.children.length - 1 || !elementsMargin
                ? 0
                : elementsMargin;
            widthArray.push(widthArray[i - 1] + containerItem.offsetWidth + margin);
        }
    }
    return widthArray;
}
//# sourceMappingURL=getWidthArray.js.map